import { Card, Layout, SkeletonBodyText } from '@shopify/polaris';
import React, { memo } from 'react';

function BaseSkeletonLayout({ elementCount = 3 }) {
  return (
    <Layout>
      {Array.from({ length: elementCount }, (_, index) => (
        <React.Fragment key={index}>
          <Layout.Section>
            <Card>
              <SkeletonBodyText lines={9} />
            </Card>
          </Layout.Section>
        </React.Fragment>
      ))}
    </Layout>
  );
}

export default memo(BaseSkeletonLayout);
